/**
 * Escapes a value for safe interpolation inside an inline `<script>` body.
 * `JSON.stringify` alone does NOT escape `<` — so any string carrying the
 * bytes `</script>` (from SCAPI custom attributes, a quirky merchandising
 * title, etc.) would otherwise close the inline script tag and turn the rest
 * into HTML. Mirrors React's own escape pass for inline JSON.
 *
 * Use from every inline `<script>` component that interpolates user/CMS data.
 */
export const safeJsonForScript = (value: unknown): string =>
  JSON.stringify(value).replace(/</g, "\\u003c").replace(/-->/g, "--\\u003e");
